<template>
    <div class="rotator images-rotator">
        <div class="image slide" 
            :class="isActiveClass(index)"
            v-for="(image, index) in images" 
            :key="'image-' + index"
            :style="{backgroundImage: `url(${image.permalink})`}">
        </div>
        <div v-if="images.length > 1" class="button-container">
            <button class="button-arrow-left inverted" @click.prevent="showPrev">
                <svg class="icon-arrow-right" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 57 101.7" style="enable-background:new 0 0 57 101.7;" xml:space="preserve">
                    <polygon style="fill:currentColor;" points="6.1,0 0,6.1 44.7,50.9 0,95.6 6.1,101.7 57,50.9 "/>
                </svg>
            </button>
            <button class="button-arrow-right inverted" @click.prevent="showNext">
                <svg class="icon-arrow-right" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 57 101.7" style="enable-background:new 0 0 57 101.7;" xml:space="preserve">
                    <polygon style="fill:currentColor;" points="6.1,0 0,6.1 44.7,50.9 0,95.6 6.1,101.7 57,50.9 "/>
                </svg>
            </button>
        </div>
    </div>
</template>

<script>
import RotatorBase from './RotatorBase';
import IconQuotes from './Icons/IconQuotes';

export default {
    extends: RotatorBase,    
    components: {
        IconQuotes,
    },
    props: ['list'],
    data() {
        return {
            images: [],
            activeSlide: 0,
        }
    },

    methods: {
        parseImages() {
            const parsedList = JSON.parse(this.$props.list);
            this.images = parsedList;
        },

        showPrev() {
            this.goToPrevSlide(this.images);
        },

        showNext() {
            this.goToNextSlide(this.images);
        },

    },

    created() {
        this.parseImages();
    },

    mounted() {

    },
}
</script>